import { CONFIG_PAGES } from "@miplatform/constants";

export const CONFIG_PATHS = {
  [CONFIG_PAGES.HOME]: "/config",
  [CONFIG_PAGES.MI_SCHEDULING]: "/config/scheduling",
  [CONFIG_PAGES.MI_DISPATCH]: "/config/dispatch",
  [CONFIG_PAGES.MI_INSPECTIONS]: "/config/inspections",
  [CONFIG_PAGES.MI_ACCOUNTING]: "/config/accounting",
  [CONFIG_PAGES.MI_ESTIMATING]: "/config/estimating",
  // TODO: Uncomment when MiAI module is added in backend and planned for
  // [CONFIG_PAGES.MI_AI]: "/config/ai",
  [CONFIG_PAGES.TENANTS]: "/config/tenants",
  [CONFIG_PAGES.HR]: "/config/hr",
  [CONFIG_PAGES.DEPARTMENTS]: "/config/hr/departments",
  [CONFIG_PAGES.DEPARTMENT_USERS]: "/config/hr/departments/:id/users",
  [CONFIG_PAGES.DEPARTMENT_USER_PROFILE]:
    "/config/hr/departments/:id/users/:userId",
  [CONFIG_PAGES.DEPARTMENT]: "/config/hr/departments/:id",
  [CONFIG_PAGES.ADD_DEPARTMENT]: "/config/hr/departments/add-department",
  [CONFIG_PAGES.HOLIDAYS]: "/config/hr/holidays",
  [CONFIG_PAGES.SETTINGS]: "/config/settings",
  [CONFIG_PAGES.USERS]: "/config/hr/users",
  [CONFIG_PAGES.ROLES_HR]: "/config/hr/roles",
  [CONFIG_PAGES.OPERATIONS]: "/config/operations",
  [CONFIG_PAGES.ORDER_TEMPLATES]: "/config/operations/order-templates",
  [CONFIG_PAGES.ROLES_OPERATIONS]: "/config/operations/roles",
  [CONFIG_PAGES.RECORDABLES]: "/config/operations/recordables",
  [CONFIG_PAGES.WARRANTY_ITEMS]: "/config/operations/warranty-items",
  [CONFIG_PAGES.TRADE_TYPES]: "/config/directory/trade-types",
  [CONFIG_PAGES.DOCUMENT_TYPES]: "/config/operations/document-types",
  [CONFIG_PAGES.INSPECTION_TEMPLATES]: "/config/inspections/inspection-types",
  [CONFIG_PAGES.AUTO]: "/config/auto",
  [CONFIG_PAGES.AUTO_BUILD]: "/config/auto/build",
  [CONFIG_PAGES.ORDER_AUTO_TRIGGER]: "/config/auto/order-auto-trigger",
  [CONFIG_PAGES.WORK_ORDER_AUTO_TRIGGER]:
    "/config/auto/work-order-auto-trigger",
  [CONFIG_PAGES.AUTO_ASSIGN]: "/config/auto/assign",
  [CONFIG_PAGES.INSPECTION_AUTHORITIES]:
    "/config/operations/inspection-authorities",
  [CONFIG_PAGES.CITIES]: "/config/operations/cities",
  [CONFIG_PAGES.CAMERA_LINES]: "/config/operations/camera-lines",
};

export const MODULES_CONFIG_PATHS = {
  [CONFIG_PAGES.MI_DISPATCH]: {
    [CONFIG_PAGES.USERS]: `${CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]}/users`,
    [CONFIG_PAGES.ROLES_HR]: `${CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]}/roles`,
    [CONFIG_PAGES.BUILD_CALENDAR]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]
    }/setup/build-calendar`,
    [CONFIG_PAGES.ORDER_CALENDARS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]
    }/order-calendars`,
    [CONFIG_PAGES.LABOR_RATES]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]
    }/labor-rates`,
    [CONFIG_PAGES.CANNOT_PERFORM_REASONS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]
    }/cannot-perform-reasons`,
    [CONFIG_PAGES.MIDAY_SETTINGS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]
    }/miday-settings`,
  },
  [CONFIG_PAGES.MI_SCHEDULING]: {
    [CONFIG_PAGES.USERS]: `${CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]}/users`,
    [CONFIG_PAGES.WORK_ORDER_TEMPLATES]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/work-order-types`,
    [CONFIG_PAGES.ORDER_CALENDARS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/order-calendars`,
    [CONFIG_PAGES.WORK_ORDER_CALENDARS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/work-order-calendars`,
    [CONFIG_PAGES.WORK_ORDER_STEPS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/work-order-steps`,
    [CONFIG_PAGES.CALENDARS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/new-construction/calendars`,
    [CONFIG_PAGES.ROLES_HR]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]
    }/roles`,
  },
  [CONFIG_PAGES.MI_ACCOUNTING]: {
    [CONFIG_PAGES.USERS]: `${CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]}/users`,
    [CONFIG_PAGES.WORK_ORDER_TEMPLATES]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]
    }/work-order-types`,
    [CONFIG_PAGES.WORK_ORDER_STEPS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]
    }/work-order-steps`,
    [CONFIG_PAGES.QUICKBOOKS_INTEGRATION]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]
    }/quickbooks-integration`,
    [CONFIG_PAGES.QUICKBOOKS_IMPORT_CUSTOMERS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]
    }/quickbooks-import-customers`,
    [CONFIG_PAGES.ROLES_HR]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]
    }/roles`,
  },
  [CONFIG_PAGES.MI_INSPECTIONS]: {
    [CONFIG_PAGES.USERS]: `${CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS]}/users`,
    [CONFIG_PAGES.INSPECTION_CALENDARS]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS]
    }/inspection-calendars`,
    [CONFIG_PAGES.ROLES_HR]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS]
    }/roles`,
    [CONFIG_PAGES.INSPECTION_TEMPLATES]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS]
    }/inspection-types`,
  },
  [CONFIG_PAGES.MI_ESTIMATING]: {
    [CONFIG_PAGES.USERS]: `${CONFIG_PATHS[CONFIG_PAGES.MI_ESTIMATING]}/users`,
    [CONFIG_PAGES.ROLES_HR]: `${
      CONFIG_PATHS[CONFIG_PAGES.MI_ESTIMATING]
    }/roles`,
  },
};
